import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sort',
    standalone: false
})
export class SortPipe implements PipeTransform {
    transform(value: Array<any>, key1: string, key2: string): any {
        if (!key1 || !value || value.length <= 1) {
            return value;
        }
        // As angular uses strict mode, we have to make a copy of the array
        const toSort = [...value];
        const res = toSort.sort((item1: any, item2: any) => {
            if (item1[key1] > item2[key1]) {
                return 1;
            } else if (item1[key1] < item2[key1]) {
                return -1;
            }
            if (!key2) {
                return 0;
            }
            if (item1[key2] > item2[key2]) {
                return 1;
            } else if (item1[key2] < item2[key2]) {
                return -1;
            }
            return 0;
        });
        return res;
    }
}
